<iframe
  *ngIf="showChatbotWidget"
  id="chatbotIframe"
  class="chatbotFrame"
  allow="microphone;clipboard-read; clipboard-write;"
  [src]="chatbotBaseURL"
></iframe>

<div class="topChatBubble" *ngIf="showChatbotTopIcon && showChatbotWidget && !isFullScreen">
  <img src="../../../assets/images/chatbot/ChatbotIcon2.png" class="image-overlay" alt="Overlay Image" />
</div>

<!-- New Header and Menu -->
<app-header *ngIf="!isMapsPage" #header></app-header>
<!-- <app-menu *ngIf="!isMapsPage" [isMenuOpen]="header?.isMenuOpen" (closeMenuEvent)="header?.closeMenu()"></app-menu> -->
<app-menu *ngIf="!isMapsPage && header" [isMenuOpen]="header.isMenuOpen" (closeMenuEvent)="header.closeMenu()">
</app-menu>
<router-outlet></router-outlet>

<!-- New Footer -->
<app-footer *ngIf="!isMapsPage"></app-footer>

<div class="scroll-to-top" [ngClass]="{ 'show-scrollTop': windowScrolled }">
  <button (click)="scrollToTop()" class="go-top header-hover scroll-top" aria-label="Scroll to top icon">
    <i class="icon-up-open-big"></i>
  </button>
</div>

<!-- Added close button for text bubble on Koko -->
<div *ngIf="showChatbotMessage" class="chat-bubble" (click)="openChat()">
  <button class="textClose" (click)="closeChatMessage(); $event.stopPropagation()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
  <div class="chat-bubble-message">
    Hi my name is <b class="koko-text">koko</b>, your friendly AI Travel Assistant. Ask me anything about The Seychelles
    Islands!
  </div>
</div>

<div class="chat-widget" [ngClass]="{ 'show-scrollTop': windowScrolled }" (click)="openChat()">
  <img
    src="../../../assets/images/chatbot/chatbotIcon1.avif"
    style="height: 100px"
    alt="The Seychelles chatboat"
    loading="lazy"
    decoding="async"
  />
</div>
